<template>
    <div style="padding:30px">
        <div class="my-title">
            积分兑换优惠卷
        </div>
        <div class="dorred_wp">
            <el-tabs
                v-model="activeName"
                @tab-click="handleClick"
                style="width:100%"
            >
                <el-tab-pane label="领卷中心" name="coupon">
                    <div
                        class="dotted"
                        v-for="item in coupinsList"
                        :key="item.id"
                    >
                        <div class="pre_price">
                            <div class="pri">
                                ￥<span>{{ item.amount }}</span>
                            </div>

                            <span class="pre">{{ item.name }}</span>
                        </div>
                        <div class="pre_t">
                            <div>
                                使用条件:满{{item.enough}}
                            </div>
                            <div>
                                有效时间:{{ item.start }} 至 {{ item.end }}
                            </div>
                        </div>
                        <div class="kangm">
                            <span>兑换需 {{item.need_score}}积分</span>
                            <span @click="getCoures(item.id)">{{text}}</span>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="可使用" name="available">
                          <div
                        class="dotted"
                        v-for="item in coupinsList"
                        :key="item.id"
                    >
                        <div class="pre_price">
                            <div class="pri">
                                ￥<span>{{ item.amount }}</span>
                            </div>

                            <span class="pre">{{ item.name }}</span>
                        </div>
                        <div class="pre_t">
                            <div>
                                使用条件:满{{item.enough}}
                            </div>
                            <div>
                                有效时间:{{ item.start }} 至 {{ item.end }}
                            </div>
                        </div>
                        <div class="kangm">
                            <span>康买xx店</span>
                            <span @click="getCoures(item.id)">{{text}}</span>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="已使用" name="have">
  <div
                        class="dotted"
                        v-for="item in coupinsList"
                        :key="item.id"
                        ref="dott_active"

                    >
                        <div class="pre_price">
                            <div class="pri">
                                ￥<span>{{ item.amount }}</span>
                            </div>

                            <span class="pre">{{ item.name }}</span>
                        </div>
                        <div class="pre_t">
                            <div>
                                使用条件:满{{item.enough}}
                            </div>
                            <div>
                                有效时间:{{ item.start }} 至 {{ item.end }}
                            </div>
                        </div>
                        <div class="kangm">
                            <span>康买xx店</span>
                            <span>{{text}}</span>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="已失效" name="lost">
                        <div
                        class="dotted"
                        v-for="item in coupinsList"
                        :key="item.id"
                        ref="dott_active"
                        style="background-color: #BEBEBE;"
                    >
                        <div class="pre_price">
                            <div class="pri">
                                ￥<span>{{ item.amount }}</span>
                            </div>

                            <span class="pre">{{ item.name }}</span>
                        </div>
                        <div class="pre_t">
                            <div>
                                使用条件:满{{item.enough}}
                            </div>
                            <div>
                                有效时间:{{ item.start }} 至 {{ item.end }}
                            </div>
                        </div>
                        <div class="kangm">
                            <span>康买xx店</span>
                            <span style="background-color: #BEBEBE;">{{text}}</span>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<script>
if (localStorage.getItem("userInfo")) {
    var token = JSON.parse(localStorage.getItem("userInfo")).token;
    var header = {
        "Content-Type": "application/json",
        token: token,
        platform: "H5"
    };
}
import { shoproCoupons, couponsGet } from "@/api/index.js";
import { timestampToTime } from "../../../../util/util.js";
export default {
    data() {
        return {
            coupinsList: [],
            activeName: "coupon",
            text:'立即兑换'
        };
    },
    created() {
        this.getCoupons();
    },
    methods: {
        getCoupons() {
            //优惠卷列表
            shoproCoupons({ type: 0 }, header).then(res => {
                console.log(res);
                if (res.code != 1) {
                    return;
                }

                res.data.forEach(i => {
                    console.log(i.time);
                    // i.start = timestampToTime(i.usetime.start * 1000);
                    i.start = this.moment(i.usetime.start * 1000).format(
                        "YYYY.MM.DD"
                    );
                    i.end = this.moment(i.usetime.end * 1000).format(
                        "YYYY.MM.DD"
                    );
                    // console.log(i.time);
                });
                this.coupinsList = res.data;
                 this.text = '立即兑换'
            });
        },
        //领取优惠卷
        getCoures(id) {
            couponsGet({ id: id }, header).then(res => {
                if (res.code != 1) {
                    return this.$message.success(res.msg);
                }
                this.$message.success(res.msg);
                console.log(res);
            });
        },
        handleClick(tab, event) {

            switch (tab.index) {
                case '0':
                  this.getCoupons();
                break
                case '1':

                shoproCoupons({ type: 1 }, header).then(res => {
                console.log(res);
                if (res.code != 1) {
                    return;
                }

                res.data.forEach(i => {
                    console.log(i.time);
                    // i.start = timestampToTime(i.usetime.start * 1000);
                    i.start = this.moment(i.usetime.start * 1000).format(
                        "YYYY.MM.DD"
                    );
                    i.end = this.moment(i.usetime.end * 1000).format(
                        "YYYY.MM.DD"
                    );
                    // console.log(i.time);
                });
                this.coupinsList = res.data;
                this.text = '去使用'
            });
                    break;
                case '2':
                      shoproCoupons({ type: 2 }, header).then(res => {
                console.log(res);
                if (res.code != 1) {
                    return;
                }

                res.data.forEach(i => {
                    console.log(i.time);
                    // i.start = timestampToTime(i.usetime.start * 1000);
                    i.start = this.moment(i.usetime.start * 1000).format(
                        "YYYY.MM.DD"
                    );
                    i.end = this.moment(i.usetime.end * 1000).format(
                        "YYYY.MM.DD"
                    );
                    // console.log(i.time);
                });
                this.coupinsList = res.data;
                this.text = '已使用'

            });
                    break;
                 case '3':
                     shoproCoupons({ type: 3 }, header).then(res => {
                console.log(res);
                if (res.code != 1) {
                    return;
                }

                res.data.forEach(i => {
                    console.log(i.time);
                    // i.start = timestampToTime(i.usetime.start * 1000);
                    i.start = this.moment(i.usetime.start * 1000).format(
                        "YYYY.MM.DD"
                    );
                    i.end = this.moment(i.usetime.end * 1000).format(
                        "YYYY.MM.DD"
                    );
                    // console.log(i.time);
                });
                this.coupinsList = res.data;
                this.text = '已失效'

            });
                    break;


            }
        }
    }
};
</script>
<style lang="less" scoped>
.el-tab-pane{
    display: flex;
    flex-wrap: wrap;
}
.dott_active{
    background-color: #BEBEBE;
}
.my-title {
    font-size: 20px;
    padding: 0 10px;
    border-left: 5px solid #ff6701;
    margin-bottom: 10px;
    margin-left: -10px;
    line-height: 40px;
    font-weight: 400;
}
.dorred_wp {
    display: flex;
    width: 918px;
    flex-wrap: wrap;
    .dotted {
        position: relative;
        background-color: #ff6701;
        width: 270px;
        height: 148px;
        margin-right: 36px;
        margin-top: 32px;
        .pre_price {
            display: flex;
            padding-top: 25px;
            justify-content: space-between;
            padding-left: 27px;
            padding-right: 26px;
            .pri {
                width: 26px;
                height: 37px;
                font-size: 12px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #ffffff;
                line-height: 22px;

                span {
                    color: #ffffff;
                    width: 26px;
                    height: 37px;
                    font-size: 22px;
                }
            }
            .pre {

                height: 22px;
                font-size: 14px;
                font-family: Helvetica;
                color: #ffffff;
                line-height: 19px;
                padding-top: 5px;
            }
        }
        .pre_t {
            width: 230px;
            height: 34px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            line-height: 17px;
            padding-left: 27px;
        }
        .kangm {
            padding-top: 19px;
        }
        .kangm span:nth-child(1) {
            width: 100%;
            height: 11px;
            font-size: 8px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #fbfbfb;
            line-height: 11px;
            padding-left: 27px;
        }
        .kangm span:nth-child(2) {
            width: 65px;
            height: 19px;
            background: #5db031;
            border-radius: 9px;
            color: #fff;
            font-size: 12px;
            display: inline-block;
            float: right;
            line-height: 19px;
            text-align: center;
            margin-right: 10px;
            cursor: pointer;
        }
    }
}

.dotted:before {
    content: " ";
    width: 100%;

    position: absolute;
    border-top: 9px dotted white;
    left: 0px;
    top: -4px;
}
#pane-lost{
display: flex;
flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/views/index/mine/components/prieceExchange.vue